$(function() {
    if ($('.animated-global-banner').length) {
        let locationAnimationInterval;

        let locationGroupIndex = 0;

        let animatedBanner = $('.animated-global-banner')[0];
        let animationInterval = $(animatedBanner).data('interval');
        let animationDuration = $(animatedBanner).data('duration');

        const onIntersect = entries => {
            let entry = entries[0];

            if (entry.isIntersecting) {
                locationAnimationInterval = window.setInterval(animateLocations, animationInterval);
            } else {
                window.clearInterval(locationAnimationInterval);
            }
        };

        function animateLocations() {
            $('.location-group').removeClass('animating');

            if (locationGroupIndex >= $('.location-group').length) locationGroupIndex = 0;
            var currentlocationGroup = $('.location-group').eq(locationGroupIndex);

            var locationIndex = Math.floor(Math.random() * currentlocationGroup.find('.location').length);
            currentlocationGroup.addClass('animating');

            let location = currentlocationGroup
                .find('.location')
                .eq(locationIndex)
                .addClass('animated');

            setTimeout(function() {
                location.removeClass('animated');
            }, animationDuration);

            locationGroupIndex++;
        }

        const observer = new IntersectionObserver(onIntersect);
        observer.observe(document.querySelector('.animated-global-banner'));
    }
});
